import PropTypes from 'prop-types';
import { memo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
// material
import { Divider, IconButton, MenuItem } from '@mui/material';
// component
import Iconify from '../../../components/Iconify';
import MenuPopover from '../../../components/MenuPopover';

// ----------------------------------------------------------------------

function StoreMoreMenu({ item, status, id, onDelete, onEnable, onDisable, onEdit }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const handleCloseMenu = () => {
    setIsOpen(false);
  };

  const handleOpenMenu = (event) => {
    setIsOpen(event.currentTarget);
  };

  const handleEnableClick = (id) => {
    onEnable(id);
    setIsOpen(false);
  };
  const handleDeleteClick = (id) => {
    onDelete(id);
    setIsOpen(false);
  };
  const handleDisableClick = (id) => {
    onDisable(id);
    setIsOpen(false);
  };

  const handleEditClick = () => {
    onEdit(item);
    console.log({ item });
    setIsOpen(false);
  };

  return (
    <>
      <MoreMenuButton
        open={isOpen}
        onClose={handleCloseMenu}
        onOpen={handleOpenMenu}
        actions={
          <>
            <MenuItem onClick={handleEditClick}>
              <Iconify icon={'eva:edit-fill'} />
              {t('edit')}
            </MenuItem>

            <MenuItem onClick={() => handleEnableClick(id)} disabled={status === 'Active'}>
              <Iconify icon={'eva:checkmark-circle-2-fill'} />
              {t('enable')}
            </MenuItem>

            <MenuItem onClick={() => handleDisableClick(id)} disabled={status === 'Inactive'}>
              <Iconify icon={'ep:circle-close'} />
              {t('disable')}
            </MenuItem>

            <Divider sx={{ borderStyle: 'dashed' }} />

            <MenuItem onClick={() => handleDeleteClick(id)} sx={{ color: 'error.main' }}>
              <Iconify icon={'eva:trash-2-outline'} />
              {t('delete')}
            </MenuItem>
          </>
        }
      />
    </>
  );
}

export default memo(StoreMoreMenu);

// ----------------------------------------------------------------------

MoreMenuButton.propTypes = {
  actions: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
};

function MoreMenuButton({ actions, open, onOpen, onClose }) {
  const ref = useRef(null);
  return (
    <>
      <IconButton ref={ref} size="large" color="inherit" sx={{ opacity: 0.7 }} onClick={onOpen}>
        <Iconify icon={'eva:more-vertical-fill'} width={20} height={20} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={ref.current}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        arrow="right-top"
        sx={{
          mt: -0.5,
          width: 'auto',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            '& svg': { mr: 2, width: 20, height: 20 },
          },
        }}
      >
        {actions}
      </MenuPopover>
    </>
  );
}
